// extracted by mini-css-extract-plugin
export default {"mouseLink":"MouseLink_mouseLink__CrENy"};